module.exports = __webpack_public_path__ + "static/media/PoweredByDQ_Default.b4180095.png";